import { Account } from 'appwrite';
import client from './appwrite';
import { api } from './api';

// Initialize Account
const account = new Account(client);

export const authService = {
  // Register a new user (without password - API auto-generates one)
  register: async (email, name, phone) => {
    try {
      // ADD DEBUG LOGGING
      console.log('=== authService.register called ===');
      console.log('email:', email);
      console.log('name:', name);
      console.log('phone:', phone);
      console.log('phone type:', typeof phone);
      console.log('phone === undefined:', phone === undefined);
      console.log('phone === "":', phone === '');
      console.log('=== Calling api.users.register ===');
      
      // Call the userAuth API to create the user (no session needed)
      const response = await api.users.register(email, name, phone);
      
      console.log('=== api.users.register response ===');
      console.log('response:', response);
      
      if (!response.success) {
        throw new Error(response.message || 'Registration failed');
      }
      
      // Return a user object with the userId
      return {
        $id: response.userId,
        email,
        name,
        phone
      };
    } catch (error) {
      console.error('Registration error:', error);
      throw error;
    }
  },
  
  // Log in user
  login: async (email, password) => {
    try {
      // Check if there's an active session first
      try {
        const currentSession = await account.getSession('current');
        
        // If we reach here, there's an active session
        // We should delete it first before creating a new one
        await account.deleteSession('current');
      } catch (sessionErr) {
        // No active session or other error - that's fine, we can proceed
        // console.log('No active session:', sessionErr);
      }
      
      // Now create a new session
      const session = await account.createEmailPasswordSession(email, password);
      
      // Set the local storage flag AFTER successful login
      localStorage.setItem('appwrite_session', 'true');
      
      return session;
    } catch (error) {
      console.error('Login error:', error);
      // Make sure we don't set the flag if login failed
      localStorage.removeItem('appwrite_session');
      throw error;
    }
  },
  
  // Log out user
  logout: async () => {
    try {
      const result = await account.deleteSession('current');
      localStorage.removeItem('appwrite_session');
      return result;
    } catch (error) {
      console.error('Logout error:', error);
      // Even if logout fails, clear the local flag
      localStorage.removeItem('appwrite_session');
      throw error;
    }
  },
  
  // Get current user
  getCurrentUser: async () => {
    // Check local storage first
    const hasSession = localStorage.getItem('appwrite_session');
    if (!hasSession) {
      return null;
    }
    // Now try to get the user details
    try {
      const user = await account.get();
      
      return {
        $id: user.$id,  // Use $id to match Appwrite convention
        email: user.email,
        name: user.name,
        phone: user.phone || '', // Get phone from native field
        prefs: user.prefs || {}
      };
    } catch (error) {
      // Instead of throwing an error, just return null for unauthenticated users
      if (error.code === 401) {
        // Invalid session, clear the flag
        localStorage.removeItem('appwrite_session');
        return null; // User is not authenticated, which is fine
      }
      // For other errors, we might still want to log them
      console.error('Error getting current user:', error);
      localStorage.removeItem('appwrite_session');
      return null;
    }
  },
  
  // Update user preferences (keeping this for other preferences, not phone)
  updatePrefs: async (prefs) => {
    try {
      return await account.updatePrefs(prefs);
    } catch (error) {
      console.error('Update prefs error:', error);
      throw error;
    }
  }
};